<!--
     <LineChart
       title="My title"
       :chardata="chardata"
     >

     chardata = {
       horitzontal: false, // default
       entries: {
         'My line 1': [
           {y: 123, x: 1, name: 'Patata'}
         ],
       },
     }
-->

<template>
  <highcharts
    :options="chart_options"
    ref="chart"
    style="width: 100%; height: 100%;"
  />
</template>


<style lang="scss">
</style>


<script>
 /* import { computed } from 'vue'; */

 export default {
   name: "LineChart",

   props: {
     title: {required: true},
     subtitle: {required: false},
     chardata: {required: true},
   },

   computed: {
     chart_options() {
       return {
         chart: {
           type: 'line',
           zoomType: 'y'
         },
         title: {
           text: '',
         },
         subtitle: {
           text: this.subtitle,
         },
         xAxis: {
           type: 'category',
           title: {
             text: null
           },
           accessibility: {
             description: this.subtitle,
           }
         },
         yAxis: {
           title: {
             text: null,
           },
           labels: {
             overflow: 'justify',
             format: '{value}'
           }
         },

         series: Object.entries(this.chardata.entries).map(([key, values]) => ({
           name: key,
           data: values,
         })),

         plotOptions: {
           column: {
             dataLabels: {
               enabled: true,
               format: '{y}'
             }
           }
         },
         tooltip: {
           valueSuffix: '',
           stickOnContact: true,
           backgroundColor: 'rgba(255, 255, 255, 0.93)'
         },
         legend: {
           enabled: false
         },
         credits: {
           enabled: false
         },
       };
     },
   },
 };
 
</script>
